<ion-content class="main-admin">
  <app-header [isParentPage]="false" [title]="'Main Admin'"></app-header>

  <ion-grid>
    <ion-row>

      <ion-col size="12" size-md="4">
        <ion-card>
          <ion-card-header>
            <ion-card-title class="ion-text-center">Site Administration</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateUserAdmin()">
              User Administration
            </ion-button>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateSettingAdmin()">
              Web Site Settings Admin
            </ion-button>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateSettingHandheld()">
              Handheld Settings Admin
            </ion-button>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateCost()">
              Customer Cost Center Admin
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="12" size-md="4">
        <ion-card>
          <ion-card-header>
            <ion-card-title class="ion-text-center">Web Order Administration</ion-card-title>
          </ion-card-header>
         <ion-card-content>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateWebOrder()">
              View Web Orders
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="12" size-md="4">
        <ion-card>
          <ion-card-header>
            <ion-card-title class="ion-text-center">Custom Reports</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateCustomerSite()">
              Custom Site Reports
            </ion-button>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateCustomAdmin()">
              Custom Reports Admin
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <!-- <ion-col size="12" size-md="4">
        <ion-card>
          <ion-card-header>
            <ion-card-title class="ion-text-center">New Order Admin</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateUserAdmin()">
              Packages
            </ion-button> 
            <ion-button expand="block" class="light-grey-button ion-margin-bottom" (click)="navigateCost()">
               View Orders 
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col> -->

    </ion-row>
  </ion-grid>
</ion-content>
